import { useState, useEffect } from 'react';
import { formatPartyCountdown } from '../utils/audioUtils';

const usePartySession = (
  partySession,
  currentItem,
  isRadioMode,
  videoElement
) => {
  const [partyCountdown, setPartyCountdown] = useState(null);

  useEffect(() => {
    if (
      !partySession ||
      partySession.itemId !== currentItem.id ||
      isRadioMode
    ) {
      setPartyCountdown(null);
      return;
    }

    const checkPartyTime = () => {
      const now = Date.now();
      const diff = partySession.startTime - now;

      if (diff > 0) {
        setPartyCountdown(formatPartyCountdown(diff));
        if (videoElement && !videoElement.paused) videoElement.pause();
      } else {
        setPartyCountdown(null);
        if (videoElement) {
          const offset = Math.abs(diff) / 1000;
          if (offset < (videoElement.duration || 3600)) {
            if (Math.abs(videoElement.currentTime - offset) > 2) {
              videoElement.currentTime = offset;
            }
            if (videoElement.paused) videoElement.play().catch(() => {});
          }
        }
      }
    };

    const interval = setInterval(checkPartyTime, 1000);
    checkPartyTime(); // Initial check

    return () => clearInterval(interval);
  }, [partySession, currentItem.id, isRadioMode, videoElement]);

  return partyCountdown;
};

export default usePartySession;
